import React from 'react';

const InlineSVG = ({ src, element, ...props }) => {
  const Element = element || 'i';

  return (
    <Element dangerouslySetInnerHTML={{ __html: src }} {...props} />
  );
};

export default InlineSVG;



// WEBPACK FOOTER //
// ./src/components/InlineSVG/index.js